import { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { useParams } from "react-router-dom";
import { getBlogById, updateBlogById } from "../../services/blogService";
import CrossIcon from "../../assets/CrossIcon";

export default function EditBlog() {
  const { blog_id } = useParams();
  const editorRef = useRef(null);
  const [blog, setBlog] = useState({});
  const [blogLoading, setBlogLoading] = useState(true);
  const [editorContent, setEditorContent] = useState(null);
  const [blogTitle, setBlogTitle] = useState("");

  useState(() => {
    const fetchBlogById = async () => {
      const res = await getBlogById(blog_id);
      setBlog(res?.data);
      setBlogTitle(res?.data?.name);
      setEditorContent(res?.data?.blog_text);
      setSelectedDate(res?.data?.created_at.split("T")[0]);
      setBlogLoading(false);
    };
    fetchBlogById();
  }, []);

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  // image upload
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const clearPreviewImage = () => {
    setSelectedFile(null);
    setBlog((prev) => {
      return {
        ...prev,
        image: null,
      };
    });
  };

  console.log(selectedFile);

  // created at

  const [selectedDate, setSelectedDate] = useState("");

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const formData = new FormData();

  selectedFile && formData.append("image", selectedFile);

  formData.append("name", blogTitle);
  formData.append("blog_text", editorContent);
  formData.append("created_at", selectedDate);

  const [saveLoading, setSaveLoading] = useState(false);
  const handleSaveClick = async () => {
    setSaveLoading(true);
    await updateBlogById(blog_id, formData);
    setSaveLoading(false);
  };

  // clearing image from frontend

  return blogLoading ? (
    <div className="px-20 py-12 min-h-screen"> Loading... </div>
  ) : (
    <>
      <div className="flex items-center py-4 px-8 bg-slate-50">
        <div className="text-xl font-semibold  pl-4 ">{blogTitle}</div>
        <button
          onClick={handleSaveClick}
          disabled={saveLoading}
          className={`ml-auto bg-sky-600 text-white px-4 py-2 rounded disabled:bg-gray-300`}>
          {saveLoading ? "Saving..." : "Save"}
        </button>
      </div>
      <div className="mx-auto px-10 py-4 flex flex-col gap-1">
        <div className="text-lg font-medium text-gray-700">Blog Title</div>
        <div className="">
          <input
            type="text"
            value={blogTitle}
            onChange={(e) => {
              setBlogTitle(e.target.value);
            }}
            className="p-2 border border-gray-300 rounded"
          />
        </div>

        <div className="text-lg font-medium pt-4 text-gray-700">
          Blog Thumbnail
        </div>

        {selectedFile || blog?.image ? (
          <div className="flex gap-2 items-start">
            <div className="w-[20rem] aspect-[3/4]">
              <img
                src={
                  selectedFile
                    ? URL.createObjectURL(selectedFile)
                    : process.env.REACT_APP_BACKEND_BASE_URL + blog?.image
                }
                alt="Preview"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
            <div onClick={clearPreviewImage} className="">
              <CrossIcon />
            </div>
          </div>
        ) : (
          <input
            type="file"
            onChange={handleFileChange}
            onClick={(e) => {
              e.target.value = null;
            }}
            className="file:mr-4 file:py-2 file:px-4 file:border-0  
                     file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700  
                     hover:file:bg-violet-100 rounded"
          />
        )}
      </div>

      <div
        htmlFor="created_at"
        className="text-lg px-10 font-medium text-gray-700 pt-2">
        Created At
      </div>
      <div className="px-10">
        <input
          type="date"
          id="created_at"
          name="created_at"
          value={selectedDate}
          onChange={handleDateChange}
          className="p-2 border border-gray-300 rounded"
        />
      </div>

      <div className="px-10 pt-4 min-h-screen flex flex-col gap-2">
        <div className="text-lg font-medium text-gray-700">Blog Text</div>
        <Editor
          apiKey="pjt5bfg4kzoyvwbyoj30szphy9ldeb2tf2jnutvapl5vyzxj"
          onInit={(_evt, editor) => (editorRef.current = editor)}
          value={editorContent}
          onEditorChange={handleEditorChange}
          init={{
            height: "650",
            menubar: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "help",
              "wordcount",
            ],
            toolbar:
              "undo redo | blocks | " +
              "bold italic forecolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
    </>
  );
}
